
import { defineComponent } from 'vue'

import NewslettersSignupStepLayout from '~/components/NewslettersSignup/NewslettersSignupStepLayout.vue'

export default defineComponent({
  name: 'NewslettersSignupThankYou',
  components: {
    NewslettersSignupStepLayout,
  },
  computed: {
    title () {
      return this.$t('newslettersSignup.step3.title')
    },
    subtitle () {
      return this.$t('newslettersSignup.step3.subtitle')
    },
  },
})

